// hooks
import { useHistory, useLocation } from 'react-router-dom'
import { MountpointMap } from 'api'
import { useToken } from 'App'
import useStyles from '../../styles'
// components
import { Tooltip } from 'react-leaflet'
import MountpointMarker from './MountpointMarker'

interface Props {
  mountpoints: MountpointMap[]
  onClick: (latlng: L.LatLng) => void
}
const MountpointsLayer = ({ mountpoints, onClick }: Props) => {
  const classes = useStyles()

  const { pathname } = useLocation()
  const { push } = useHistory()

  const { userRole } = useToken()

  const getMarkerColor = (mountpoint: MountpointMap) => {
    let color = '#499e22'

    // if (mountpoint.coord_alert) color = '#e74615'
    if (mountpoint.inactive) color = '#5F6368'
    else if (!mountpoint.connected) color = '#c62626'
    else if (mountpoint.unstable) color = '#bbb919'

    return color
  }

  return (
    <>
      {mountpoints.map((mountpoint) => (
        <MountpointMarker
          position={[mountpoint.latitude, mountpoint.longitude]}
          eventHandlers={{
            click: ({ latlng }) => {
              onClick(latlng)
              if (userRole !== 'regular' && !/measurement/i.test(pathname))
                push(`/mountpoint/${mountpoint.id}/info`)
            },
          }}
          coordAlert={mountpoint.coord_alert}
          color={getMarkerColor(mountpoint)}
          key={mountpoint.id}
        >
          <Tooltip direction="top" permanent className={classes.mountpointTooltip}>
            {mountpoint.name}
          </Tooltip>
        </MountpointMarker>
      ))}
    </>
  )
}

export default MountpointsLayer
